import { PanayaRoute } from '@frontend-site/shared/router-store';
import { LoopbackComponent, OldSitePendingChangesGuard } from '@frontend-site/shared/hybrid';

export const TM_REPORTS_ROUTES: PanayaRoute = Object.freeze<PanayaRoute>({
    path: 'reports',
    canDeactivate: [OldSitePendingChangesGuard],
    children: [
        {
            path: '',
            component: LoopbackComponent,
            data: { navState: 'tm.reports', rememberMe: { pageId: 'reports', group: 'project' } }
        },
        {
            path: 'testsStatusProgress',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.testsStatusProgress' }
        },
        {
            path: 'testingProgressForecast',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.testingProgressForecast' }
        },
        {
            path: 'plannedVsActual',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.plannedVsActual' }
        },
        {
            path: 'modulePriorityReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.modulePriorityReport' }
        },
        {
            path: 'overlappingRequirements',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.overlappingRequirements' }
        },
        {
            path: 'workflowsApprovalStatus',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.workflowsApprovalStatus' }
        },
        {
            path: 'changeRequests',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.changeRequests' }
        },
        {
            path: 'testCoverageReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.testCoverageReport' }
        },
        {
            path: 'sapObjectsGrid',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.sapObjectsGrid' }
        },
        {
            path: 'omegaTestCoverageReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.omegaTestCoverageReport' }
        },
        {
            path: 'omegaDeltaAnalysisReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.omegaDeltaAnalysisReport' }
        },
        {
            path: 'omegaSapObjectsGrid',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.omegaSapObjectsGrid' }
        },
        {
            path: 'objectDetails/:id',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.objectDetails' }
        },
        {
            path: 'txnsByUsersReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.txnsByUsersReport' }
        },
        {
            path: 'txnsByUserSapObjectsGrid',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.txnsByUserSapObjectsGrid' }
        },
        {
            path: 'txnsByUserObjectDetails/:id',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.txnsByUserObjectDetails' }
        },
        {
            path: 'correctionsProgress',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.correctionsProgress' }
        },
        {
            path: 'manageEffortFactors',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.manageEffortFactors' }
        },
        {
            path: 'burnDownReportByPlannedVsActual',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.burnDownReportByPlannedVsActual' }
        },
        {
            path: 'hanaActivitySummary',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.hanaActivitySummary' }
        },
        {
            path: 'assessmentPackReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.assessmentPackReport' }
        },
        {
            path: 'deletedTxnsReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.s4DeletedTxnsReport' }
        },
        {
            path: 'deletedTxnsReportModule',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.s4DeletedTxnsReportDD' }
        },
        {
            path: 's4SiRelevancyReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.s4SiRelevancyReport' }
        },
        {
            path: 's4ImpactedTestReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.s4ImpactedTestReport' }
        },
        {
            path: 's4SiRelevancyReportAppArea',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.s4SiRelevancyReportDD' }
        },
        {
            path: 'accCoverageReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.accCoverageReport' }
        },
        {
            path: 'fioriApplications',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.fioriApplicationsReport' }
        },
        {
            path: 'requirements',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.requirements' }
        },
        {
            path: 'projectOverview',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.projectOverview' }
        },
        {
            path: 'developmentProgress',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.developmentProgress' }
        },
        {
            path: 'projectCapacityReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.projectCapacityReport' }
        },
        {
            path: 'projectDevCapacityReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.projectDevCapacityReport' }
        },
        {
            path: 'projectTestCapacityReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.projectTestCapacityReport' }
        },
        {
            path: 'signatureReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.signatureReport' }
        },
        {
            path: 'recentAnalysisSummaryReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.recentAnalysisSummary' }
        },
        {
            path: 'automaticCodeCorrectionProgressReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.automaticCodeCorrectionProgress' }
        },
        {
            path: 'atcAndPanayaDataComparisonReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.atcAndPanayaDataComparison' }
        },
        {
            path: 'updatedTasksReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.updatedTasks' }
        },
        {
            path: 'comments',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.taskComments' }
        },
        {
            path: 'codeQuality',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.requirementsCqIssues' }
        },
        {
            path: 'report/:reportName',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.defectReport' }
        },
        {
            path: 'correctionToUTReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.correctionsToUnitTestsReport' }
        },
        {
            path: 'correctionToFuncReport',
            component: LoopbackComponent,
            data: { navState: 'tm.reports.correctionsToFunctionalTestsReport' }
        }
    ]
});
